import { render, staticRenderFns } from "./NaoEncontrado.vue?vue&type=template&id=56e76886&"
import script from "./NaoEncontrado.vue?vue&type=script&lang=js&"
export * from "./NaoEncontrado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports